<template>
  <div id="trainings" style="width: 100%;">
    <div class="desktop">
      <div style="display: flex">
        <div class="col-title">
          PERSONAL
          <br />DEVELOPMENT
        </div>
        <div class="col-title">
          CAREER
          <br />DEVELOPMENT
        </div>
      </div>
      <div class="content" style="width: 100%;">
        <div
          v-for="training in trainings"
          :key="training.title"
          class="row"
          style="display: flex; width: 100%"
        >
          <div
            class="training left-color"
            @click="showModal(training.left)"
            :class="{ selected_elem: training.left.selected }"
          >
            <div class="training-content">
              <div class="training-content-title">
                {{ training.left.title }}
              </div>
              <div class="training-content-description">
                {{ training.left.description }}
              </div>
              <span>...</span>
            </div>
          </div>

          <div
            class="training right-color"
            @click.stop="showModal(training.right)"
            :class="{ selected_elem: training.right.selected }"
          >
            <div class="training-content">
              <div class="training-content-title">
                {{ training.right.title }}
              </div>
              <div class="training-content-description">
                {{ training.right.description }}
              </div>
              <span>...</span>
            </div>
          </div>
        </div>
        <!-- <div style="display: flex; justify-content: center" @click.stop="showModal(lastTraining)">
          <div class="training right-color" v-bind:id="lastTraining.id">
            <div class="training-content">
              <div class="training-content-title">{{ lastTraining.title }}</div>
              <div class="training-content-description">{{ lastTraining.description }}</div>
              <span>...</span>
            </div>
          </div>
        </div>-->
      </div>
    </div>
    <div class="mobile">
      <div class="col-title">
        PERSONAL
        <br />DEVELOPMENT
      </div>
      <div
        v-for="training in trainings"
        :key="training.title"
        @click.stop="showModal(training.left)"
        style="width: 100%;"
      >
        <div
          class="training left-color"
          v-bind:id="training.left.id"
          :class="{ selected_elem: training.left.selected }"
        >
          <div class="training-content">
            <div class="training-content-title">{{ training.left.title }}</div>
            <div class="training-content-description">
              {{ training.left.description }}
            </div>
            <span>...</span>
          </div>
        </div>
      </div>
      <div class="col-title">
        CAREER
        <br />DEVELOPMENT
      </div>
      <div
        v-for="training in trainings"
        :key="training.title"
        @click.stop="showModal(training.right)"
        style="width: 100%;"
      >
        <div
          class="training right-color"
          v-bind:id="training.left.id"
          :class="{ selected_elem: training.right.selected }"
        >
          <div class="training-content">
            <div class="training-content-title">{{ training.right.title }}</div>
            <div class="training-content-description">
              {{ training.right.description }}
            </div>
            <span>...</span>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL -->

    <v-dialog v-model="dialog" content-class="dialog2" width="500">
      <v-card>
        <v-card-title class="headline">{{ modalObject.title }}</v-card-title>
        <v-card-text>{{ modalObject.description }}</v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      modalObject: {
        title: "",
        description: "",
      },
      trainings: [
        {
          left: {
            selected: false,
            id: "training-left-0",
            title: "Self Understanding",
            description:
              "Înțelegerea sinelui și a mecanismelor de gândire din spatele unei decizii sunt vitale în parcursul individual. Astfel, acest training caută să identifice relația cu sinele și moduri în care aceasta poate fi îmbunătățită pentru a ușura drumul fiecăruia.",
          },
          right: {
            selected: false,
            id: "training-right-0",
            title: "Career guidance",
            description:
              "O persoană prezintă un tip de interes profesional principal, pentru care urmează o facultate, alături de un interes profesional secundar. Acest training se va axa pe găsirea intereselor profesionale secundare, care pot fi din domeniile tehnice, artistice, sociale, investigative, convenționale sau antreprenoriale.",
          },
        },
        {
          left: {
            selected: false,
            id: "training-left-1",
            title: "How to learn efficiently",
            description:
              "Există numeroase metode concepute pentru învățarea și acumularea eficientă de informații. Scopul acestui training este acela de a descoperi mijloacele cele mai potrivite pentru a reține logic informație și individualizarea acestora pentru rezultate optime.",
          },
          right: {
            selected: false,
            id: "training-right-1",
            title: "How to reach your full potential",
            description:
              "Valorile individuale și dezvoltarea fac parte din fundamentul unei cariere. Prin acest training se urmăresc amplificarea dorinței naturale de evolutie și concretizarea unor direcții care sunt în concordanță cu planul de cariera dorit.",
          },
        },
        {
          left: {
            selected: false,
            id: "training-left-2",
            title: "Public Speaking",
            description:
              "Tracul de scenă este prezent la circa 74% din persoanele adulte. Astfel, acest training are ca scop îmbunătățirea abilităților de a vorbi în public prin tehnici de livrare a mesajului și folosirea limbajelor paraverbal și nonverbal ca emfază a discursului.",
          },
          right: {
            selected: false,
            id: "training-right-2",
            title: "Job Interview",
            description:
              "Abilitățile necesare pentru livrarea unui interviu reușit reprezintă o nouă necesitate a societății noastre. Prin acest training se urmărește conturarea metodelor prin care un candidat își poate crește șansele de reușită ale unui interviu și prin care se poate prezenta pe sine.",
          },
        },
        {
          left: {
            selected: false,
            id: "training-left-3",
            title: "Creative Thinking",
            description:
              "Creativitatea însumează moduri de regăsire și exprimare a sinelui necesare pentru o gândire armonioasă. Acest training își propune explorarea acestei laturi și identificarea metodelor prin care poate ajuta în dezvoltarea personală.",
          },
          right: {
            selected: false,
            id: "training-right-3",
            title: "Strategic Thinking",
            description:
              "Gândirea strategică reprezintă primul pas în derularea unui plan de afaceri reușit. Acest training urmărește crearea unui mod de a gândi clar și obiectiv, cu ajutorul căruia scopul propus se poate implementa printr-un plan strategic mulat pe obiectivele alese.",
          },
        },
        {
          left: {
            selected: false,
            id: "training-left-4",
            title: "Emotional Intelligence",
            description:
              "Ți-a fost vreodată dificil să identifici limita dintre emoții și raționalitate? Trainingul de inteligență emoțională are ca scop diferențierea trăirilor de judecata logică și împăcarea acestora pentru a evita conflictele interioare.",
          },

          right: {
            selected: false,
            id: "training-right-4",
            title: "Assertion",
            description:
              "Exprimarea clară a ideilor și a gândurilor reprezintă instrumentul de bază pentru o relaționare reușită. Acest training va contura metode de exprimare clară a ideilor, alături de mijloace de preluare a inițiativelor atunci când vine vorba de planul profesional.",
          },
        },
        {
          left: {
            selected: false,
            id: "training-left-5",
            title: "Stress Management",
            description:
              "Prevenția factorilor stresori este la fel de importantă ca gestionarea ulterioară a acestora. Trainingul de Stress Management va cuprinde aspecte ale vieții cotidiene, ca sportul, alimentația, cariera și dezvoltarea personală, folosite ca mijloace de înlăturare a stresului. De asemenea, trainingul va include și tehnici de gestionare ale momentelor de stress.",
          },
          right: {
            selected: false,
            id: "training-right-5",
            title: "Negotiation Skills",
            description:
              "Negocierea înglobează expunerea beneficiilor care pot fi oferite și a acelora care sunt dorite, totul pentru încheierea cât mai avantajoasă a unei înțelegeri. Prin acest training se urmărește adaptarea la cerințele propuse și finalizarea cât mai lină a unui comun acord.",
          },
        },
        {
          left: {
            selected: false,
            id: "training-left-6",
            title: "Time Management",
            description:
              "Simți că ești constant stresat de evenimentele care țin de facultate sau de viața socială? Acest training urmărește prioritizarea activităților și evitarea supraaglomerării acestora pentru a spori organizarea și eficiența personală.",
          },
          right: {
            selected: false,
            id: "training-right-6",
            title: "Problem Solving",
            description:
              "Fiecare loc de muncă prezintă situații imprevizibile sau probleme care necesită a fi rezolvate individual sau în echipă. Trainingul de Problem Solving vine în ajutorul celor care doresc să afle strategii optime prin care să abordeze aceste evenimente și să învețe mijloacele potrivite prin care să le soluționeze.",
          },
        },
      ],
    };
  },
  methods: {
    showModal(training) {
      this.modalObject = training;
      this.dialog = true;
    },
  },
  mounted() {
    for (let row of this.trainings) {
      //am uitat ca exista forEach
      if (row.right.title == this.$route.params.id) {
        row.right.selected = true;
      }
      if (row.left.title == this.$route.params.id) {
        row.left.selected = true;
      }
    }
  },
};
</script>

<style lang="scss" scoped>
@keyframes blinker {
  50% {
    opacity: 0;
  }
}

.selected_elem {
  animation: blinker 1s linear 2;
}

#trainings {
  background: #0d2a4c;
  padding: 0 !important;
  margin: 0 !important;
}
.col-title {
  width: 50%;
  color: white;
  font-size: 30px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 40px;
}
.left-color {
  background: #f37298;
}
.right-color {
  background: #0d9599;
}
.training {
  padding-left: 35px;
  border-radius: 40px;
  width: 65%;
  min-width: 350px;
  max-width: 450px;
  margin-top: 40px;
  cursor: pointer;
}
.training-content {
  background: white;
  border-radius: 40px;
  padding: 20px;
  padding-left: 40px;
  &-title {
    font-weight: bold;
    font-size: 20px;
    margin-bottom: 15px;
  }
  &-description {
    font-size: 16px;
    height: 75px;
    line-height: 25px;
    overflow: hidden;
  }
}

.row:nth-child(odd) {
  justify-content: space-around;
}

.row:nth-child(even) {
  justify-content: center;
  .left-color {
    margin-right: 3%;
    @media (min-width: 1600px) {
      margin-right: 6%;
    }
  }
  .right-color {
    margin-left: 3%;
    @media (min-width: 1600px) {
      margin-left: 6%;
    }
  }
}
.desktop {
  display: block;
  width: 100%;
}
.mobile {
  display: none;
  width: 100%;
}

@media only screen and (max-width: 600px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: block;
  }
  .col-title {
    width: 100%;
    font-size: 15px;
    font-weight: bold;
    text-align: center;
    margin-bottom: 30px;
    padding-top: 30px;
  }
  .left-color {
    margin-right: 0%;
  }
  .right-color {
    margin-left: 0%;
  }
  .training {
    padding-left: 10px;
    padding-right: 10px;
    border-radius: 22px;
    width: 80%;
    min-width: 0px;
    max-width: 80%;
    margin: auto;
    margin-top: 30px;
  }
  .training-content {
    background: white;
    border-radius: 22px;
    padding: 15px;
    padding-left: 20px;
    &-title {
      font-weight: bold;
      font-size: 16px;
      margin-bottom: 10px;
    }
    &-description {
      font-size: 12px;
      height: 60px;
      line-height: 20px;
    }
  }
}
</style>
